import { render, staticRenderFns } from "./UserSwitch.vue?vue&type=template&id=5c6912de&scoped=true"
import script from "./UserSwitch.vue?vue&type=script&lang=js"
export * from "./UserSwitch.vue?vue&type=script&lang=js"
import style0 from "./UserSwitch.vue?vue&type=style&index=0&id=5c6912de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6912de",
  null
  
)

/* custom blocks */
import block0 from "./UserSwitch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports